import React from 'react';
import connect from "react-redux/es/connect/connect";
import DashboardContainer from "./DashboardContainer";
import { STATUS_ERROR, STATUS_SUCCESS } from "../../actions";
import styles from "./Dashboard.module.scss"
import GettingStartedContent from "./GettingStartedContent"
import { servicesMap } from '../../consts/sevicesMap';

import { ReactComponent as CalculatorIcon } from "ui-components/src/images/2-colors-icons/ic-calculator.svg";
import { ReactComponent as PricingIcon } from "ui-components/src/images/2-colors-icons/ic-pricing.svg";
import { ReactComponent as ApiIcon } from "ui-components/src/images/2-colors-icons/ic-api.svg";
import { ReactComponent as DemoIcon } from "ui-components/src/images/2-colors-icons/ic-demo.svg";
import { ReactComponent as AutomationIcon } from "ui-components/src/images/2-colors-icons/ic-automation.svg";
import { ReactComponent as RocketshipIcon } from "ui-components/src/images/2-colors-icons/ic-get-started.svg";
import { ReactComponent as FeaturesAndPricingIcon } from "ui-components/src/images/2-colors-icons/ic-features-pricing.svg";
import { ReactComponent as PerformanceIcon } from "ui-components/src/images/2-colors-icons/ic-feature-flags.svg";

import { ReactComponent as AzureLogo } from 'ui-components/src/images/third-party-services/logo-azure.svg';
import { ReactComponent as GoogleCloudLogo } from 'ui-components/src/images/third-party-services/logo-google-cloud.svg';
import { ReactComponent as AWSLogo } from 'ui-components/src/images/third-party-services/logo-aws.svg';

import { registerFeature } from "../../middlewares/apiMiddleware";

import dashboardsMiddleware from "../../middlewares/featureApis/dashboardsMiddleware";
import Loadable from 'react-loadable';
import {Redirect, Route, Switch, NavLink} from "react-router-dom";
import ExternalLink from "../widgets/ExternalLink";

registerFeature("DASHBOARDS", dashboardsMiddleware);
const CloudVolumesOntapLogo = servicesMap["cloud-volumes-ontap"].banner;
const CloudVolumesServiceLogo = servicesMap["cloud-volumes-service"].banner;
const CloudSyncLogo = servicesMap["cloud-sync"].banner;
const CloudBackupLogo = servicesMap["cloud-backup-service"].banner;
const CloudInsightsLogo = servicesMap["cloud-insights"].banner;
const CloudTieringLogo = servicesMap["cloud-tiering"].banner;
const SaaSBackupLogo = servicesMap["saas-backup"].banner;


const CloudSyncActivatedDashboard = Loadable({
    loader: ()  => import('./CloudSyncActivatedDashboard' /* webpackChunkName: "CloudSyncActivatedDashboard" */),
    loading: () => <div/>
});


const CloudSyncDashboardDumb = ({ cloudSync }) => {
    return (cloudSync.status === STATUS_SUCCESS || cloudSync.status === STATUS_ERROR) && <DashboardContainer
        category="services"
        serviceKey="cloudSync"
        title="Cloud Sync"
        Icon={CloudSyncLogo}
        iconStyle={{width: 94, height: 94}}
        productText="Cloud Sync is NetApp’s service for rapid and secure data synchronization. Whether you need to transfer files between on-premises NFS or CIFS file shares, Amazon S3 object format, Azure Blob, IBM Cloud Object Storage or NetApp StorageGRID® Webscale appliance, Cloud Sync moves the files where you need them quickly and securely."
        gettingStartedLink="dashboards.cloudSync.gettingStarted"
        contactUsEmail="saas.support@netapp.com"
        gettingStartedContent={[
            {
                Icon: DemoIcon,
                title: "FAQ",
                text: "Frequently asked questions",
                linkKey: "dashboards.cloudSync.faq"
            },
            {
                Icon: PricingIcon,
                title: "Supported Sync Relationships",
                text: "Learn about the supported source and target protocols for data transfer",
                linkKey: "dashboards.cloudSync.supportedSyncRelationships"
            },
            {
                Icon: ApiIcon,
                title: "API",
                text: "Cloud Sync Rest API",
                linkKey: "dashboards.cloudSync.api"
            }
        ]}
        footerContent={{
            title: "Cloud Sync Documentation & Support",
            links: [
                {
                    text: "Getting Started Guide",
                    linkKey: "dashboards.cloudSync.gettingStarted"
                },
                {
                    text: "Documentation",
                    linkKey: "dashboards.cloudSync.documentation"
                },
                {
                    text: "FAQ",
                    linkKey: "dashboards.cloudSync.faq"
                },
                {
                    text: "Blog",
                    linkKey: "dashboards.cloudSync.blog"
                }
            ]
        }}
        ActivatedDashboard={cloudSync.status === STATUS_SUCCESS && CloudSyncActivatedDashboard}
    />
};

const mapStateToPropsCloudSync = state => {
    return {
        cloudSync: state.services.cloudSync
    };
};

export const CloudSyncDashboard = connect(mapStateToPropsCloudSync)(CloudSyncDashboardDumb);

export const CloudVolumesOntapDashboard = () => <DashboardContainer
    category="storage"
    title="Cloud Volumes ONTAP"
    serviceKey="cloudVolumesOntap"
    Icon={CloudVolumesOntapLogo}
    iconStyle={{width: 148, height: 94}}
    productText="Cloud Volumes ONTAP is a powerful, cost-effective, and easy-to-use data management solution for your cloud workloads. The familiar and reliable Cloud Volumes ONTAP data management software with its data protection and storage efficiency features, now available in the AWS, Azure cloud and Google Cloud."
    gettingStartedLink="dashboards.cloudVolumesOntap.gettingStarted"
    contactUsEmail="saas.support@netapp.com"
    gettingStartedContent={[
        {   Icon: CalculatorIcon,
            title: "TCO Calculator",
            text: "Calculate your Cloud Volumes ONTAP TCO on AWS and Azure",
            linkKey: "dashboards.cloudVolumesOntap.tcoCalculators"
        },
        {   Icon: PricingIcon,
            title: "Pricing",
            text: "Cloud Volumes ONTAP pricing for AWS and Azure",
            linkKey: "dashboards.cloudVolumesOntap.pricing"
        },
        {   Icon: ApiIcon,
            title: "API",
            text: "Cloud Volumes ONTAP Rest API",
            linkKey: "dashboards.cloudVolumesOntap.api"
        },
        {   Icon: AutomationIcon,
            title: "Automation Samples",
            text: "Cloud Manager and Cloud Volumes ONTAP automation samples",
            linkKey: "dashboards.cloudVolumesOntap.automationSamples"
        }
    ]}
    footerContent={{
        title: "Cloud Volumes ONTAP Documentation & Support",
        links: [
            {
                text: "Getting Started Guide",
                linkKey: "dashboards.cloudVolumesOntap.gettingStarted"
            },
            {
                text: "Documentation",
                linkKey: "dashboards.cloudVolumesOntap.documentation"
            },
            {
                text: "API",
                linkKey: "dashboards.cloudVolumesOntap.api"
            },
            {
                text: "Blog",
                linkKey: "dashboards.cloudVolumesOntap.blog"
            }
        ]
    }}
/>;

const CVSAzure = () => <React.Fragment>
    <p>A Microsoft Azure native service built on NetApp technology, giving you the file capabilities in Azure even your core business applications require.</p>
    <ExternalLink linkKey="launchPad.services.cloudVolumesServiceAzurePreview" trackCategory="dashboards" className={styles['cta-no-center']} newTab>Subscribe to the Service</ExternalLink>
    <GettingStartedContent gettingStartedContent={[
        {
            Icon: RocketshipIcon,
            title: "Get Started with Azure NetApp Files",
            linkKey: "dashboards.cloudVolumesServiceAzure.getStarted"
        },
        {
            Icon: PerformanceIcon,
            title: "Get to know the performance of Azure NetApp Files",
            linkKey: "dashboards.cloudVolumesServiceAzure.performance"
        },
        {
            Icon: FeaturesAndPricingIcon,
            title: "Features and Pricing",
            linkKey: "dashboards.cloudVolumesServiceAzure.featuresAndPricing"
        }
    ]}/>
</React.Fragment>;

const CVSGCP = () => <React.Fragment>
    <p>A Google Cloud integrated file service with the performance, availability, and security required to efficiently run your business-critical applications.</p>
    <ExternalLink linkKey="launchPad.services.cloudVolumesServiceGooglePreview" trackCategory="dashboards" className={styles['cta-no-center']} newTab>Subscribe to the Service</ExternalLink>
    <GettingStartedContent gettingStartedContent={[
        {
            Icon: DemoIcon,
            title: "Learn More About Cloud Volumes Service for GC",
            linkKey: "dashboards.cloudVolumesServiceGcp.learnMore"
        },
        {
            Icon: PerformanceIcon,
            title: "Get to know the performance of Cloud Volumes Service for GC",
            linkKey: "dashboards.cloudVolumesServiceGcp.performance"
        },
        {
            Icon: FeaturesAndPricingIcon,
            title: "Features and Pricing",
            linkKey: "dashboards.cloudVolumesServiceGcp.featuresAndPricing"
        }
    ]}/>
</React.Fragment>;

const CVSAWS = () => <React.Fragment>
    <p>Extreme Performance for File Services</p>
    <ExternalLink linkKey="launchPad.services.cloudVolumesServiceAwsSubscription" trackCategory="dashboards" className={styles['cta-no-center']} newTab>Subscribe to the Service</ExternalLink>
    <GettingStartedContent gettingStartedContent={[
        {
            Icon: RocketshipIcon,
            title: "Get Started with Cloud Volumes Service for AWS",
            linkKey: "dashboards.cloudVolumesServiceAws.getStarted"
        },
        {
            Icon: PerformanceIcon,
            title: "Get to know the performance of Cloud Volumes Service for AWS",
            linkKey: "dashboards.cloudVolumesServiceAws.performance"
        },
        {
            Icon: FeaturesAndPricingIcon,
            title: "Features and Pricing",
            linkKey: "dashboards.cloudVolumesServiceAws.featuresAndPricing"
        }
    ]}/>
</React.Fragment>;

const CloudVolumesServiceCustom = () => <section className={styles["cloud-volumes-service-custom"]}>
    <h5>Fully managed, cloud service that enables you to move your mission-critical workloads and applications to the cloud, and manage them with ease. Available in Azure, AWS, and Google Clouds.</h5>
    <div className={styles["cloud-volumes-service-switcher-container"]}>
        <NavLink to="/dashboard/cloud-volumes-service/azure" className={styles['cloud-volumes-service-switcher']} activeClassName={styles['cvs-active']}><AzureLogo/></NavLink>
        <NavLink to="/dashboard/cloud-volumes-service/gcp" className={styles['cloud-volumes-service-switcher']} activeClassName={styles['cvs-active']}><GoogleCloudLogo/></NavLink>
        <NavLink to="/dashboard/cloud-volumes-service/aws" className={styles['cloud-volumes-service-switcher']} activeClassName={styles['cvs-active']}><AWSLogo/></NavLink>
    </div>
    <div className={styles["cloud-volumes-service-container"]}>
        <Switch>
            <Route path="/dashboard/cloud-volumes-service/azure" render={() => <CVSAzure/>}/>
            <Route path="/dashboard/cloud-volumes-service/gcp" render={() => <CVSGCP/>}/>
            <Route path="/dashboard/cloud-volumes-service/aws" render={() => <CVSAWS/>}/>
            <Redirect to="/dashboard/cloud-volumes-service"/>
        </Switch>
    </div>
</section>;

export const CloudVolumesServiceDashboard = () => <DashboardContainer
    category="storage"
    title="Cloud Volumes Service"
    serviceKey="cloudVolumesService"
    Icon={CloudVolumesServiceLogo}
    CustomPane={CloudVolumesServiceCustom}
    iconStyle={{width: 120, height: 125}}
/>;

export const CloudInsightsDashboard = () => <DashboardContainer
    category="analytics"
    title="Cloud Insights"
    serviceKey="cloudInsights"
    Icon={CloudInsightsLogo}
    iconStyle={{width: 118, height: 80}}
    productText="NetApp Cloud Insights is an infrastructure monitoring tool that gives you visibility into your complete infrastructure. With Cloud Insights, you can monitor, troubleshoot and optimize all your resources including your public clouds and your private data centers."
    gettingStartedLink="dashboards.cloudInsights.gettingStarted"
/>;

export const SaaSBackupDashboard = () => <DashboardContainer
    category="services"
    title="SaaS Backup"
    serviceKey="saasBackup"
    Icon={SaaSBackupLogo}
    iconStyle={{width: 103, height: 103}}
    productText={["SaaS Backup is a cloud-native, secure and comprehensive data protection solution to safeguard your business-critical data hosted in cloud applications like Microsoft Office 365 and Salesforce against accidental or malicious deletions.", 
"Available as Software as a Service (SaaS) offering, it eliminates the need to install, upgrade or maintain software.",
"One of the key features offered by SaaS Backup is the greater flexibility to choose data storage location. You can either let NetApp store your backup data in Amazon Web Services (AWS) or Microsoft Azure multitenant cloud repository or Bring Your Own Storage(BYOS)- NetApp StorageGrid WebScale.",
"Additionally, with key features like unlimited storage, granular recovery and single-click restore NetApp SaaS Backup puts you in complete control and helps to preserve critical business operations"]}
    gettingStartedContent={[
        {
            Icon: DemoIcon,
            title: "Already Signed Up?",
            text: "Start exploring SaaS Backup",
            linkKey: "dashboards.saasBackup.explore"
        },
        {
            Icon: PricingIcon,
            title: "Need help while getting started?",
            text: "Read Quick Start Guide",
            linkKey: "dashboards.saasBackup.quickStart"
        },
        {
            Icon: ApiIcon,
            title: "Have a query?",
            text: "Post it here",
            linkKey: "dashboards.saasBackup.query"
        }
    ]}
    footerContent={{
        title: "SaaS Backup Documentation & Support",
        links: [
            {
                text: "Blog",
                linkKey: "dashboards.saasBackup.blog"
            },
            {
                text: "Contact Us",
                linkKey: "dashboards.saasBackup.contactUs"
            },
            {
                text: "Documentation",
                linkKey: "dashboards.saasBackup.documentation"
            }
        ]
    }}
/>;

export const CloudTieringDashboard = () => <DashboardContainer
    category="services"
    title="Cloud Tiering"
    serviceKey="cloudTiering"
    Icon={CloudTieringLogo}
    iconStyle={{width: 101, height: 86}}
    productText="Lift and don't shift. Free up high-performance AFF storage space by automatically tiering data to the cloud. NetApp’s Cloud Tiering service allows you to retain your on-prem, high-performance AFF (and FAS SSD) storage and combine it with the benefits of cloud economics, leveraging the low costs of Azure Blob, Amazon S3, and IBM Cloud Object Storage."
/>;

export const CloudBackupServiceDashboard = () => <DashboardContainer
    category="services"
    title="Cloud Backup Service"
    serviceKey="cloudBackup"
    Icon={CloudBackupLogo}
    iconStyle={{width: 103, height: 93}}
    productText="Cloud Backup Service is an integrated feature for Cloud Volumes Service. It delivers fully managed backup and restore capabilities for protection, and long-term archive of your cloud data."
/>;